import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import OnboardingPage from "./pages/OnboardingPage";
import DashboardPage from "./pages/DashboardPage";
import NewCapturePage from "./pages/NewCapturePage";
import SOPLibraryPage from "./pages/SOPLibraryPage";
import SOPDetailPage from "./pages/SOPDetailPage";
import AskTheBrainPage from "./pages/AskTheBrainPage";
import SettingsPage from "./pages/SettingsPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><Layout><DashboardPage /></Layout></ProtectedRoute>} />
          <Route path="/capture" element={<ProtectedRoute><Layout><NewCapturePage /></Layout></ProtectedRoute>} />
          <Route path="/library" element={<ProtectedRoute><Layout><SOPLibraryPage /></Layout></ProtectedRoute>} />
          <Route path="/library/:sopId" element={<ProtectedRoute><Layout><SOPDetailPage /></Layout></ProtectedRoute>} />
          <Route path="/brain" element={<ProtectedRoute><Layout><AskTheBrainPage /></Layout></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Layout><SettingsPage /></Layout></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
